// extracted by mini-css-extract-plugin
module.exports = {"progress":"ValueProgress_progress__51K_o"};